import { React, useState, useEffect, useMemo } from "react";
import csv from 'csvtojson';

// import "../App.css";
import Map from './Map'
import Select from "react-select";
import EicCodeBlock from "../EicCodeBlock";


/*
  Use this for when we put back in automatic reading of the csv file and show all function types
*/
/*
const selectOptions = new Set([
  ...areacodes
    .filter((a) => a.EicTypeFunctionList)
    .map((a) => {
      const { EicTypeFunctionList } = a;
      // console.log(EicTypeFunctionList)
      if (!EicTypeFunctionList) {
        console.log("Null function");
      }
      return EicTypeFunctionList.split(", ");
    })
    .flat(),
]);
*/

/*
  On request we are to only show the following functions
*/
const selectOptions = [
  'Member State',
  'Control Area',
  // 'Market Balance Area',
  'Capacity Calculation Region',
  'Bidding Zone',
  'Scheduling Area',
  'Synchronous Area' // removing this as this function does not exist in https://docs.entsoe.eu/bites/eic/Y_eiccodes.csv
]


const SYNCHRONOUS_AREAS_CODES = [
  "10Y1001A1001A91G",
  "10Y1001A1001A59C",
  "10YGB----------A",
  "10YEU-CONT-SYNC0",
  "10Y1001A1001A94A"
]


function MapView() {
  const [areacodes, setAreacodes] = useState([]);
  const [selectedFunction, setSelectedFunction] = useState({value: 'Member State', label: 'Member State'});
  const [selectedEicCode, setSelectedEicCode] = useState(null);

  const filterCodesList = () => {
    // Removed in favour of function list
    // const options = areacodes.map(a => {
    //   return {
    //     value: a.EicCode, label: `${a.EicCode}  - ${a.EicDisplayName}`
    //   }
    // })

    const options = [...selectOptions].map((o) => {
      return {
        value: o,
        label: o,
      };
    });

    return <Select isClearable={false} value={selectedFunction} options={options} onChange={onChange} />;
  };

  

  const onChange = option => {
    setSelectedFunction(option);
  }

  const filteredAreas = useMemo(()=> {
    const value = selectedFunction.value;

    if (value === 'Synchronous Area') {
      return areacodes.filter((a) => a.EicTypeFunctionList && SYNCHRONOUS_AREAS_CODES.indexOf(a.EicCode) !== -1);
    }

    return areacodes.filter((a) => a.EicTypeFunctionList && a.EicTypeFunctionList.includes(value));
  }, [areacodes, selectedFunction]);

  const filterAreasReturnIds = (option) => {
    return filteredAreas.map(a => a.EicCode);
  }

  useEffect(()=> {
    fetch('https://eepublicdownloads.entsoe.eu/eic-codes-csv/Y_eiccodes.csv')
      .then((res) => {
        return res.text();
      }).then((data) => {
        return csv({delimiter: 'auto'}).fromString(data);
      }).then((json) => {
        setAreacodes(json);
      }).catch(console.error);
  }, []);

  const handleZoneClick = (id) => {
    console.log(`Clicked this zone ${id}`)
    const foundArea = areacodes.find(a => a.EicCode === id)
    if (foundArea) {
      setSelectedEicCode(foundArea);
    }
  }
  // useMemo(
  //   () => (id) => {
  //     trackEvent('countryClick');
  //     dispatchApplication('isLeftPanelCollapsed', false);
  //     history.push({ pathname: `/zone/${id}`, search: location.search });
  //   },
  //   [trackEvent, history, location],
  // );

  return (
    <div className="App">
      <div
        style={{
          position: 'relative',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '5px',
            left: '10px',
            width: '200px',
            zIndex: 1,
          }}
        >
          {filterCodesList()}
          {selectedEicCode && <EicCodeBlock orientation="vertical" withMap={false} code={selectedEicCode}/> }
        </div>
       
        <Map
          zoneIds={filterAreasReturnIds(selectedFunction)}
          onZoneClick={handleZoneClick}
        >
        </Map>
      </div>
    </div>
  );
}

export default MapView;
